export const DEFAULT_SCALE = 2;
